"use client";

import React from "react";
import { Facebook, Instagram, Linkedin, Mail, MapPin, Phone, Twitter } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3].map((_, i) => <li key={i} data-index={i} className="h-4 w-24 bg-muted animate-pulse rounded-md" />)}
      </ul>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <ul className="space-y-3">
        <li data-index={0}>
          
        </li>
        <li data-index={1}>
          
        </li>
        <li data-index={2}>
          <Link to="#" className="font-default font-normal text-sm text-muted-foreground hover:text-primary transition-colors">
            Longevidade Profissional
          </Link>
        </li>
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="font-default font-normal text-sm text-muted-foreground hover:text-primary transition-colors">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function FraternalFooter() {
  const brotherhoodLinks = [];
  const contactInfo = [{
    icon: Phone,
    text: "+ 55 11 966 187 866"
  }, {
    icon: Mail,
    text: "\xA0rede.masterproplus@gmail.com"
  }];
  const socialLinks = [{
    icon: Linkedin,
    href: "https://www.linkedin.com/company/masterpromais/",
    label: "Linkedin"
  }];
  return <section data-section-id="252273" id="footer" className="bg-background border-t border-border ![padding:24px_0px_32px_0px]">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="grid grid-cols-1 gap-12 mb-12 md:grid-cols-3 lg:grid-cols-3 lg:gap-8">
          
          {}
          <div className="flex flex-col gap-6">
            <Link to="/HomePage" className="inline-block w-fit">
              <WvcLogo className="text-foreground !w-[80px] [&_svg]:text-foreground [&_svg]:!w-[80px]" />
            </Link>
            <p className="text-sm text-muted-foreground leading-relaxed font-default font-normal">MASTERPRO+ é o ecossistema de serviços e soluções para líderes que buscam longevidade profissional, reposicionamento e influência estratégica no mercado.</p>
          </div>

          {}
          

          {}
          <div className="flex flex-col gap-6">
            
            <ul className="space-y-3">
              {brotherhoodLinks.map((link, i) => <li key={i} data-index={i}>
                  <Link to={link.path} className="font-default font-normal text-sm text-muted-foreground hover:text-primary transition-colors">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-6 ![padding:7px_0px_7px_0px]">
            <h3 className="font-serif font-bold text-lg text-foreground tracking-wide">
              Contato
            </h3>
            <ul className="space-y-4">
              {contactInfo.map((info, i) => {
              const Icon = info.icon;
              return <li key={i} data-index={i} className="flex items-start gap-3 text-sm text-muted-foreground">
                    <Icon className="size-4 text-primary shrink-0 mt-0.5" />
                    <span className="font-default">{info.text}</span>
                  </li>;
            })}
            </ul>
            <div className="flex items-center gap-3 mt-2">
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              return <Button key={i} data-index={i} variant="outline" size="icon" className="rounded-none size-9 border-border hover:border-primary hover:text-primary transition-colors bg-transparent" asChild>
                    <Link to={social.href} aria-label={social.label}>
                      <Icon className="size-4" />
                    </Link>
                  </Button>;
            })}
            </div>
          </div>
        </div>

        {}
        <Separator className="mb-8 bg-border/30" />
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-muted-foreground font-default font-normal">
          <p>© 2026 MASTERPRO+. Todos os direitos reservados. - Desenvolvido por ITC Mais&nbsp;</p>
          <div className="flex items-center gap-4">
            <Link to="/HomePage" className="hover:text-primary transition-colors">Política de Privacidade</Link>
            <Link to="/HomePage" className="hover:text-primary transition-colors">Termos de Uso</Link>
          </div>
        </div>
      </div>
    </section>;
}